import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M12 10.5c.26 0 .53 0 .78.04.11.02.22.05.33.09.7.24 1.29.78 1.75 1.32.88 1.02 1.61 1.89 2.48 2.91 1.31 1.31 2.92 2.76 2.61 4.8-.29 1.01-1.02 2.03-2.33 2.32-.73.14-3.06-.44-5.54-.44h-.18c-2.48 0-4.81.59-5.54.44-1.31-.29-2.04-1.3-2.33-2.32-.3-2.03 1.31-3.48 2.62-4.79.88-1.02 1.61-1.89 2.48-2.91.47-.54 1.05-1.08 1.75-1.32.11-.04.22-.07.33-.09.26-.05.53-.05.79-.05zM4.5 7C5.8807 7 7 8.1193 7 9.5S5.8807 12 4.5 12 2 10.8807 2 9.5 3.1193 7 4.5 7zm15 0C20.8807 7 22 8.1193 22 9.5S20.8807 12 19.5 12 17 10.8807 17 9.5 18.1193 7 19.5 7zM9 3c1.3807 0 2.5 1.1193 2.5 2.5S10.3807 8 9 8 6.5 6.8807 6.5 5.5 7.6193 3 9 3zm6 0c1.3807 0 2.5 1.1193 2.5 2.5S16.3807 8 15 8s-2.5-1.1193-2.5-2.5S13.6193 3 15 3z",
    fillRule: "evenodd"
  }],
  circles: []
};
var PetsIcon = function PetsIcon(props) {
  return renderIcon(props, iconType);
};
export { PetsIcon };